import { noop } from '@aloft/toolkit-shared';

import { RefObject, useEffect, useState } from 'react';

import { useGoogleMapsLoader } from './useGoogleMapsLoader.ts';

export const useStreetViewPanorama = (streetViewRef: RefObject<HTMLDivElement>) => {
  const [streetViewPanorama, setStreetViewPanorama] = useState<google.maps.StreetViewPanorama>();

  const loader = useGoogleMapsLoader();

  useEffect(() => {
    const initialize = async () => {
      if ((!loader || !streetViewPanorama) && streetViewRef.current) {
        const StreetViewLibrary = await loader.importLibrary('streetView');

        setStreetViewPanorama(
          new StreetViewLibrary.StreetViewPanorama(streetViewRef.current, {
            visible: false,
          }),
        );
      }
    };

    initialize().then(noop).catch(console.error);
  }, [loader, streetViewRef, streetViewPanorama]);

  return streetViewPanorama;
};
